import { FC, useEffect, useState } from 'react'
import cn from 'classnames'

import { ReactComponent as Spinner } from '@src/assets/spinner.svg'
import style from '@src/components/common/Preloader/Preloader.module.scss'

type PreloaderProps = {
  loading: boolean
  center?: boolean
  isOver?: boolean
}

export const Preloader: FC<PreloaderProps> = ({
  children, loading, center, isOver,
}) => {
  const [innerLoading, setInnerLoading] = useState(loading)
  const bothLoading = loading || innerLoading

  useEffect(() => {
    if (loading) {
      setInnerLoading(true)
      setTimeout(() => {
        setInnerLoading(false)
      }, 1000)
    }
  }, [loading])

  return (
    <>
      <div className={cn(bothLoading && style.disabled)}>{children}</div>
      {bothLoading && (
        <div className={style.container}>
          <div className={style.content}>
            {isOver && children}
          </div>
          <div className={cn(center && style.center, isOver && style.over)}>
            <Spinner />
          </div>
        </div>
      )}
    </>
  )
}
